import { render, staticRenderFns } from "./TrEdit.vue?vue&type=template&id=02b827a4&scoped=true&"
import script from "./TrEdit.vue?vue&type=script&lang=js&"
export * from "./TrEdit.vue?vue&type=script&lang=js&"
import style0 from "./TrEdit.vue?vue&type=style&index=0&id=02b827a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b827a4",
  null
  
)

export default component.exports